module.exports = __webpack_public_path__ + "static/media/gcm.0f45a709.png";